window._ = require('lodash');

try {
  window.$ = window.jQuery = require('jquery');
  window.toastr = require('toastr');

  require('bootstrap');
  require('jquery-ui');
  require('select2');
  require('@fortawesome/fontawesome-free/js/all');
  require('firebase/app');
} catch (e) {
}

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
